import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import ProtectedRoute from './components/auth/ProtectedRoute/ProtectedRoute';
import TopNav from './components/common/TopNav/TopNav';
import { AuthProvider } from './contexts/AuthContext';
import SmartOrderCapture from './pages/AIOrders/AIOrders';
import Home from './pages/Home/Home';
import Inventory from './pages/Inventory/Inventory';
import Mapeamentos from './pages/Mapeamentos/Mapeamentos';
import Orders from './pages/Orders/Orders';
import Reports from './pages/Reports/Reports';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <ProtectedRoute>
            <TopNav />
            <div className="main-content">
              <Routes basename="/services/app">
                <Route path="/" element={<Home />} />
                <Route path="/inventory" element={<Inventory />} />
                <Route path="/orders" element={<Orders />} />
                <Route path="/smart-order-capture" element={<SmartOrderCapture />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/mapeamentos" element={<Mapeamentos />} />
              </Routes>
            </div>
          </ProtectedRoute>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
